<template>
  <div class="index restaurant">
    
    <van-notice-bar
      v-if="enableEpidemic"
      mode="closeable"
      wrapable
      :scrollable="false"
      :text="epidemicContent"
    />

    <header>
      <van-search
        class="restaurant-search"
        v-model="keyword"
        placeholder="搜索餐厅"
        @search="onSearch"
      />
    </header>

    <van-skeleton title :row="2" :loading="loading" >
      <van-dropdown-menu class="restaurant-filter">
        <van-dropdown-item
          v-model="cityId"
          :options="cities"
          @change="onFilter"
        >
          <template #title>
              <van-icon name="location-o" color="#333" /> {{getOption(cities , cityId)}}
          </template>
        </van-dropdown-item>
        <van-dropdown-item
          v-model="styleId"
          :options="cookingStyles"
          @change="onFilter">
          <template #title>
            <van-icon name="fire-o" color="#333" /> {{getOption(cookingStyles , styleId)}}
          </template>
        </van-dropdown-item>
        <van-dropdown-item
          v-model="priceId"
          :options="prices"
          @change="onFilter">
          <template #title>
            <van-icon name="gold-coin-o" color="#333" /> {{getOption(prices , priceId)}}
          </template>
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-skeleton>
    <van-skeleton title :row="6" :loading="loading" ></van-skeleton>
    <van-list @load="onPullRefresh">
      <section class="rest-card" v-for="rest in restaurants" :key="rest.id">
        <div class="rest-header">
          <div>
            <div class="rest-name">{{ rest.name }}</div>
            <div class="rest-info">
              <span>{{rest.cookingStyle}}</span>
              <span>人均：¥{{rest.pricePerPerson}}/人</span>
              <template v-if="rest.dishs.length > 0">
                <span>{{ rest.dishs.length }}道折扣招牌菜</span>
              </template>
              <span>{{rest.cityName}}</span>
            </div>
          </div>
          <van-button class="btn-order" type="primary" @click="onBooking(rest.id)">预定</van-button>
        </div>
        <van-image width="100%" height="160px" fit="cover" 
          lazy-load
          :src="resetImageUrl(rest.imageUrl,0,0)"
          @click="onRestaurantDetails(rest.id)" />
      </section>
    </van-list>
  </div>
  <Nav active="restaurant"></Nav>
</template>

<script>
import { reactive, toRefs, onMounted, onActivated, onDeactivated, nextTick } from "vue";
import { useRouter} from "vue-router";
import Nav from "../components/Nav.vue"
import Controller from "./restaurant-controller";
import "../css/restaurant.scss";

export default {
  name: "Restaurant",
  components: {
    Nav
  },
  setup() {
    const state = reactive({
      member: null,
      restaurants: [],
      cityId: 0,
      cities:[],
      styleId: 0,
      cookingStyles: [],
      priceId: 0,
      prices: [],
      keyword: "",
      loading: true,
      pullRefresh: false,
      enableEpidemic: false,
      epidemicContent: ""
    });
    const router = useRouter();
    const onRestaurantDetails = (id) => router.push("/restaurant/" + id);
    const onBooking = id => router.push("/restaurant/" + id);
    const onSearch = () => Controller.searchRestaurants(state);
    const onFilter = () => Controller.filterRestaurants(state);
    const getOption = (values , id) => Controller.getOption(values ,id);
    const onPullRefresh = () => {
        if( state.pullRefresh ) {  //skip
          return ;
        }
        state.pullRefresh = true;
        Controller.pullRefreshRestaurants(state).then(() => state.pullRefresh = false);
    } 
    onMounted(() => Controller.onMounted(state , router));

    // 滚动位置记录与恢复（配合 keep-alive）
    let savedScrollTop = 0
    onActivated(() => {
      // console.log('[Restaurant] onActivated, savedScrollTop:', savedScrollTop)
      if (savedScrollTop > 0) {
        // 使用 nextTick 确保 DOM 渲染完成后再恢复滚动位置
        nextTick(() => {
          // 兼容多种滚动容器
          const scrollTarget = document.scrollingElement || document.documentElement || document.body
          scrollTarget.scrollTop = savedScrollTop
          window.scrollTo(0, savedScrollTop)
          console.log('[Restaurant] 滚动位置已恢复至:', savedScrollTop, '实际位置:', window.scrollY)
        })
      }
    })
    onDeactivated(() => {
      const currentScroll = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      savedScrollTop = currentScroll
      // console.log('[Restaurant] onDeactivated, 保存滚动位置:', savedScrollTop)
    })

    return {
      ...toRefs(state),
      onRestaurantDetails,
      onSearch,
      onFilter,
      onBooking,
      onPullRefresh,
      getOption,
      resetImageUrl: Controller.resetImageUrl
    };
  },
};
</script>
